export const formatCurrency = (amount: number): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);

/** Format a numeric string with thousands separators (e.g. "5000" → "5,000"). */
export const formatWithCommas = (value: string): string => {
  const digits = String(value ?? "").replace(/[^\d]/g, "");
  if (!digits) return "";
  return Number(digits).toLocaleString("en-US");
};

/** Strip non-digit characters and return the raw numeric string for storage. */
export const stripNonNumeric = (value: string): string =>
  String(value ?? "").replace(/[^\d]/g, "");

